import { ActionReducer, MetaReducer } from '@ngrx/store';
import { resetAllState } from './auth/auth.actions';

/**
 * Meta-reducer that resets the entire application state when the resetAllState
 * action is dispatched. This ensures all reducers are reset to their initial state.
 */
export function storeReset<T>(reducer: ActionReducer<T>): ActionReducer<T> {
  return (state, action) => {
    if (action.type === resetAllState.type) {
      return reducer(undefined, action);
    }
    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer[] = [storeReset]; 